import { useMutation } from '@tanstack/react-query'
import { NoContent } from '@/common/types_and_interfaces.ts'
import { ApiCallResult } from '@/lib/tanstack-utils.types.ts'
import axios from 'axios'
import { parseRequestError } from '@/common/utilities.ts'

export type FixedDistributionPayload = {
  base_amount: number
}

export type UpdateFixedParams = {
  programId: number
  purseId: number
}

const updateFixedDistribution = async (
  params: UpdateFixedParams,
  payload: FixedDistributionPayload
): Promise<NoContent> => {
  const { programId, purseId } = params

  try {
    await axios.post(
      `/programs/${programId}/purses/${purseId}/settings/fixed_distribution`,
      payload
    )
    return null
  } catch (e) {
    throw parseRequestError(e)
  }
}

type RequestPayload = {
  params: UpdateFixedParams
  payload: FixedDistributionPayload
}
export const useUpdateFixedDistribution = (): ApiCallResult<
  NoContent,
  RequestPayload
> => {
  return useMutation({
    mutationFn: async ({ params, payload }: RequestPayload) => {
      return await updateFixedDistribution(params, payload)
    },
  })
}
